import React from "react";

import Badge from "../ui/Badge";
import { orderState } from "../../static/materialLine";

const OrderStatusBadge = ({ status }: { status: number }) => {
  const state = orderState(status);

  return (
    <Badge variant="none" className={state.badgeClass}>
      {state.label}
    </Badge>
  );
};

export default OrderStatusBadge;
